export const types = {
  GALLERY_REQUEST: 'GALLERY_REQUEST',
  GALLERY_SUCCESS: 'GALLERY_SUCCESS',
  GALLERY_FAILURE: 'GALLERY_FAILURE',
};

export const urls = {
  GALLERY: 'companyAdmin/photos',
};
